import React from 'react';
import { Link } from 'react-router-dom';
import dotsBg from '../../assets/images/website.gif';

const articles = [
    { id: '01', title: 'Babies R’ Us', path: '/articles/babies-r-us' },
    { id: '02', title: 'The Ark of Life', path: '/articles/ark-of-life' },
    { id: '03', title: 'In Sickness and In Health', path: '/articles/in-sickness-and-health' },
    { id: '04', title: 'CRISPR and You', path: '/articles/crispr-and-you' },
];

const ArticleNavPage = () => {
    return (
        <div
            className="min-h-screen text-black px-6 md:px-20 py-16 font-bebas flex justify-center items-center"
            style={{
                backgroundImage: `url(${dotsBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }}
        >
            <div className="flex flex-col md:flex-row gap-10  md:items-start  md:text-left">

                {/* LIFE. EDITED. Heading */}
                <div className="py-1">
                    <h2 className="text-5xl md:text-6xl font-black bg-black text-white inline-block px-2 relative">
                        <span className="relative inline-block">
                            <span className="relative">LIFE.</span>
                            <span className="absolute left-0 right-0 top-1/2 h-[2px] bg-red-500  transform -translate-y-1/2" />
                        </span>
                        <span className="ml-2">EDITED.</span>
                    </h2>
                </div>

                {/* Article links */}
                <div className="space-y-6">
                    {articles.map((article) => (
                        <div key={article.id} className="flex items-baseline space-x-4 md:space-x-10  md:justify-start">
                            <span className="text-4xl md:text-7xl">{article.id}</span>
                            <Link
                                to={article.path}
                                className={`text-4xl md:text-7xl hover:text-gray-500 transition`}
                            >
                                {article.title.toUpperCase()}
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ArticleNavPage;
